var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:`minimize-btn ${_vm.minimized ? 'minimized' : ''}`,attrs:{"color":"rgba(15,15,15, 0.36)","fab":"","small":""},on:{"click":_vm.onChange}},[(_vm.minimized)?_c('v-icon',{attrs:{"color":"white","dark":""}},[_vm._v("mdi-resize")]):_c('v-icon',{attrs:{"color":"white","dark":""}},[_vm._v("mdi-move-resize-variant")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }